import React from 'react';
import FilterBox from 'components/filter-box/FilterBox';
import { Button, styled, TextField } from '@mui/material';
import KeyboardDatePicker from 'components/pickers/KeyboardDatePicker';
import { Search } from '@mui/icons-material';
import { useSurgerie } from './hooks/useSurgerie';

const Filter = styled('form')(({ theme }) => ({
  display: 'grid',
  alignItems: 'center',
  columnGap: 10,
  rowGap: 15,
  flex: 1,
  gridTemplateColumns: '1.2fr 0.9fr 0.9fr 0.9fr 100px',
  '& .date-picker': {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    columnGap: 10,
  },
  [theme.breakpoints.down('md')]: {
    gridTemplateColumns: '1fr 1fr',
  },
  [theme.breakpoints.down('sm')]: {
    gridTemplateColumns: '1fr',
  },
}));

const SurgerieOpenFilterBox: React.FC = () => {
  const { filter, handleChangeFilter, handleSearch, loading } = useSurgerie();
  return (
    <FilterBox>
      <Filter onSubmit={handleSearch}>
        <div className="date-picker">
          <KeyboardDatePicker
            fullWidth
            disableFuture
            label="Data inicial"
            value={filter.initial_date}
            onChange={date => handleChangeFilter('initial_date', date)}
          />
          <KeyboardDatePicker
            fullWidth
            disableFuture
            label="Data final"
            value={filter.final_date}
            onChange={date => handleChangeFilter('final_date', date)}
          />
        </div>

        <TextField
          label="Médico"
          placeholder="Digite o nome do médico"
          value={filter.doctor_name}
          onChange={e => handleChangeFilter('doctor_name', e.target.value)}
        />

        <TextField
          label="Paciente"
          placeholder="Digite o nome do paciente"
          value={filter.patient_name}
          onChange={e => handleChangeFilter('patient_name', e.target.value)}
        />

        <TextField
          label="Hospital"
          placeholder="Digite o nome do hospital"
          value={filter.hospital_name}
          onChange={e => handleChangeFilter('hospital_name', e.target.value)}
        />

        <Button
          type="submit"
          disabled={loading}
          variant="contained"
          color="primary"
          size="small"
          startIcon={<Search />}
        >
          Buscar
        </Button>
      </Filter>
    </FilterBox>
  );
};

export default SurgerieOpenFilterBox;
